export default class ClubMemberAccessMediumGantner {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubMemberAccessMedium = new ClubMemberAccessMediumGantner();
        clubMemberAccessMedium.id = data.id;
        clubMemberAccessMedium.name = data.name;
        clubMemberAccessMedium.accessMediumType = data.accessMediumType;
        clubMemberAccessMedium.identifier = data.identifier;
        clubMemberAccessMedium.isEditable = data.isEditable;
        clubMemberAccessMedium.isDeletable = data.isDeletable;

        Object.seal(clubMemberAccessMedium);
        return clubMemberAccessMedium;
    }

    isEmpty() {
        return !this.name && !this.identifier && !this.accessMediumType;
    }
}
